import type { Severity } from "@/api/types";
import { cn } from "@/lib/utils";

const ALL: Severity[] = ["P1", "P2", "P3", "P4"];

interface Props {
  value: Severity[];
  onChange: (next: Severity[]) => void;
}

export function SeverityFilter({ value, onChange }: Props) {
  function toggle(sev: Severity) {
    if (value.includes(sev)) {
      onChange(value.filter((v) => v !== sev));
    } else {
      onChange([...value, sev]);
    }
  }

  return (
    <div className="flex items-center gap-1">
      <span className="mr-2 text-xs uppercase tracking-wider text-muted-foreground">
        Severidad
      </span>
      {ALL.map((sev) => {
        const active = value.includes(sev);
        return (
          <button
            key={sev}
            type="button"
            onClick={() => toggle(sev)}
            aria-pressed={active}
            className={cn(
              "h-8 rounded-md border px-3 text-xs font-bold transition-colors",
              active
                ? "border-primary bg-primary text-primary-foreground"
                : "border-input bg-background text-muted-foreground hover:bg-accent",
            )}
          >
            {sev}
          </button>
        );
      })}
    </div>
  );
}
